// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function autocompleteFilter<T extends Record<string, any>>(event: { query: string }, itemsArray: T[] | null, field: string, returnFieldOnly = false): T[] {
  if (itemsArray === null) {
    return [];
  }

  let q = event.query.toLowerCase();

  if (field === 'nomeClassifica') {
    switch (event.query) {
      case 'rr':
        q = 'riservatissimo';
        break;
      case 'ss':
        q = 'segretissimo';
        break;
    }
  }

  const filtered = itemsArray.filter(i => (i[field] as string).toLowerCase().indexOf(q) !== -1);

  if (returnFieldOnly) {
    return filtered.map(i => i[field] as T);
  } else {
    return filtered;
  }
}

